

import React, { Component } from 'react';
import { BrowserRouter as Router, Route,Switch, Redirect } from "react-router-dom";
// import AnimationContainer from './animationContainer'
var AnimationContainer = null;
var AnimationContainerBehind = null
export var AnimatedRoutes = (Routes, Options)  => {
    const ANimatedMainRoute = ({ listen }) => (
    <Router>
            <Switch>
                <Route path="/"  component={Child} />
            </Switch>
    </Router>
    );
    class Child extends Component {
        constructor(props) {
            super(props)
            this.state = {
                valid:  this.checkUrl(Routes,this.props.history.location.pathname),
                location:null
            }
        }
        checkUrl = (urlArray, currentUrl) => {
            let returne = false;
            if (urlArray && currentUrl) {
            
                for(var i = 0; i < urlArray.length; i++) {
                    if (urlArray[i].route === currentUrl) {
                        returne = true;
                    }
                }
    
            }     return returne;
        
        
        }
        componentDidMount() {
            let url = this.props.location.pathname

            if(!url.includes('password') || !url.includes("reset")) {
                localStorage.setItem('url', url)
            }
            
            
        this.props.history.listen((location, action) => {
            this.setState ({
                valid:  this.checkUrl(Routes,`${location.pathname}${location.search}${location.hash}`),
                location:location,
            }) 
        });
        }
        setRoutes = (routes) => {
            Routes = routes
        }
        render() {
            if (this.state.valid) {
                if (Options && Options.inRows) {
                    if (AnimationContainer === null) {
                        AnimationContainer = require('./animationContainerRows').default
                    }
                    return (
                        <AnimationContainer 
                        parentClassName={Options && Options.parentClassName ? Options.parentClassName : ''}
                        className={Options && Options.className ? Options.className : ''}
                        options={Options}
                        availableRoutes={Routes}
                        setRoutes={this.setRoutes}
                        match={this.props.match}
                        history={this.props.history}
                        location={this.state.location}
                        />
                    );
                } else {
                    if (AnimationContainerBehind === null) {
                        AnimationContainerBehind = require('./animationContainer').default
                    }
                    return (
                        <AnimationContainerBehind 
                        parentClassName={Options && Options.parentClassName ? Options.parentClassName : ''}
                        className={Options && Options.className ? Options.className : ''}
                        options={Options}
                        availableRoutes={Routes}
                        setRoutes={this.setRoutes}
                        match={this.props.match}
                        history={this.props.history}
                        location={this.state.location}
                        />
                    );
                }
       
            } else {
                if (Options.notFoundRoute.redirect && this.props.history.location.pathname !== Options.notFoundRoute.redirect) {
                   return (
                    <Redirect to={Options.notFoundRoute.redirect}/>
                   );
                } else {
                    return (
                        // <Redirect to='/somewhere'/>
                        Options.notFoundRoute  && Options.notFoundRoute.component? <Options.notFoundRoute.component {...Options.notFoundRoute.props} /> : <div></div>
                    )
                }
              
            }

        }
    }
    // const NoMatch = ({ location }) => (
    //     <div>
    //     <h3>
    //         No match 404 for <code>{location.pathname}</code>
    //     </h3>
    //     </div>
    // );

    return ANimatedMainRoute;
}



// WEBPACK FOOTER //
// ./src/components/functional/animated-router/index.js